import { HttpEvent } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { Observable, take } from 'rxjs';
import { AttachmentService } from 'src/app/services/attachment.service';
import { EventService } from 'src/app/services/event.service';
import { AppConstants } from 'src/app/shared/app.constants';
import { AppUtils } from 'src/app/shared/app.utils';
import { AuthorizationModel } from 'src/app/shared/models/authorization-model';
import { ApplicationAttachment } from 'src/app/shared/types/attachment.types';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'ness-event-import',
  templateUrl: './event-import.component.html'
})
export class EventImportComponent implements OnInit {
  private _currentDateTime: Date;
  private _iconClass: string = 'fa-caret-down';
  private readonly attachmentType: ApplicationAttachment = 'BulkEventImportTemplate';
  readonly canImport: AuthorizationModel = {
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      { roles: ['Application Administrator', 'Power User', 'NESS Administrator'], userType: 'ATFHQ' },
      { roles: ['Application Administrator', 'Power User', 'NESS Administrator'], userType: 'ATFFieldDivision' },
      { roles: ['NESS Administrator'], userType: 'StateLocalLE' }
    ]
  } as AuthorizationModel;

  apiRoot: string = environment.apiEndpoint;
  cols: any = [];
  crimeTypeName: string;
  crimeTypes: any[];
  @ViewChild('downloadTemplateLink', { static: false }) private downloadTemplateLink: ElementRef;
  event: ServerModels.ENESS_EventDTO;
  eventImportTemplate$: Observable<ServerModels.ENESS_ApplicationAttachment> = this.attachmentService.getAttachmentByType(this.attachmentType);
  fileTransferFileName: string = '';
  fileTransferSucceeded: boolean;
  importItemId: string;
  importResults: ServerModels.ENESS_ImportItem[];
  importStatus: ServerModels.ImportStatus[];
  openViewEventForm: boolean = false;
  rows: number = AppConstants.defaultTableRows;
  uploadedFiles: any[] = [];
  utcoffset: number;

  get currentDateTime(): Date {
    return this._currentDateTime;
  }

  set currentDateTime(dt: Date) {
    this._currentDateTime = dt;
  }

  get iconClass(): string {
    return this._iconClass;
  }

  set iconClass(str: string) {
    this._iconClass = str;
  }

  constructor(private eventService: EventService,
    private attachmentService: AttachmentService,
    public elementRef: ElementRef) { }

  ngOnInit() {
    this.currentDateTime = new Date();
    this.cols = [
      { field: 'ItemUploadDateTime', header: 'Upload date/time' },
      { field: 'LECaseID', header: 'LE case number' },
      { field: 'Agency', header: 'Agency Name' },
      { field: 'CrimeType', header: 'Crime type' },
      { field: 'Status', header: 'Error messages' }
    ];
    this.getImportStatus();
    this.getUploadResult();
    this.fileTransferSucceeded = null;
    this.utcoffset = moment().utcOffset();
  }

  private getUploadResult() {
    this.eventService.getUploadResult().pipe(take(1)).subscribe({
      next: (result: ServerModels.ENESS_ImportItem[]) => {
        this.importResults = [...result] || [];
      }
    });
  }

  private getImportStatus() {
    this.eventService.getImportStatus().pipe(take(1)).subscribe({
      next: (status: ServerModels.ImportStatus[]) => {
        this.importStatus = status || [];
      }
    });
  }

  onUploadHandler(event: { originalEvent: HttpEvent<any>, files: File[] }) {
    this.fileTransferSucceeded = event.originalEvent['status'] == 200;
    this.fileTransferFileName = event.files[0].name;
  }

  onClickClose() {
    this.fileTransferSucceeded = null;
    this.getUploadResult();
  }

  onClickDownload(importTemplate: ServerModels.ENESS_ApplicationAttachment) {
    if (importTemplate) {
      const blob = AppUtils.base64toBlob(importTemplate.Attachment, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
      const link = this.downloadTemplateLink.nativeElement;
      const url = window.URL.createObjectURL(blob);
      link.href = url;
      link.click();
      window.URL.revokeObjectURL(url);
    }
  }

  refreshStatus() {
    this.getUploadResult();
    this.getImportStatus();
    this.fileTransferSucceeded = null;
    this.currentDateTime = new Date();
  }

  toggleIcon(evt: MouseEvent) {
    this.iconClass = evt.currentTarget['attributes']['aria-expanded'].value == 'true' ? 'fa-caret-left' : 'fa-caret-down';
  }

  viewEvent(selectedItem: ServerModels.ENESS_ImportItem) {
    this.eventService.getUploadedEventById(selectedItem.ItemID)
      .pipe(take(1)).subscribe({
        next: (event: ServerModels.ENESS_EventDTO) => {
          this.event = event;
          this.importItemId = selectedItem.ItemID;
        },
        complete: () => { this.openViewEventForm = true; }
      });
  }
}
